import 'spectrum-colorpicker2/dist/spectrum.min';

import colorConverter from 'color-convert';

export default class AlColorPickerController {
    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.initialValue = null;
        this.spectrumElement = null;
        this.hidePreviewRow = false;
        this.colorLabel = '';

        this.showSelector = false;
    }

    $onInit() {

    }

    $postLink() {
        this.startColor = this.initialValue || '#333333';
        this.colorInformation = this._createColorInformationFromHex(this.startColor);

        this._initializeColorPicker();
        this._initWatchers();
    }

    $onDestroy() {
        this.spectrumElement.spectrum('destroy');
    }

    openColorPicker() {
        this.showSelector = true;
    }

    selectCurrentColor() {
        this.initialValue = this.colorInformation.hex;
        this.onColorSelect({color: this.colorInformation});

        this.showSelector = false;
    }

    cancelSelection() {
        this.colorInformation.hex = this.initialValue;
        this.updateColorFromColorInformation('hex');

        this.showSelector = false;
    }

    updateColorFromColorInformation(updateBy) {
        let newColorInformation;
        switch (updateBy) {
            case 'rgb':
                newColorInformation = this._createColorInformationFromRgb(
                    this.colorInformation.rgb.r,
                    this.colorInformation.rgb.g,
                    this.colorInformation.rgb.b
                )
                break;
            default:
                newColorInformation = this._createColorInformationFromHex(this.colorInformation.hex)
                break;
        }

        this.colorInformation = newColorInformation;
        this.spectrumElement.spectrum('set', newColorInformation.hex);
    }

    _initializeColorPicker() {
        this.spectrumElement = this.element.find('.color-picker');
        this.spectrumElement.spectrum({
            color: this.startColor,
            type: 'flat',
            showPalette: false,
            showAlpha: false,
            showButtons: false,
            allowEmpty: false,
            move: (color) => {
                this._refreshColorInformation(color);
            }
        });
    }

    _refreshColorInformation(color) {
        this.colorInformation = {
            hex: color.toHexString(),
            rgb: color.toRgb()
        }

        this.scope.$applyAsync();
    }

    _createColorInformationFromHex(hexColor) {
        hexColor = hexColor
            .replace('#', '')
            .toLowerCase()
            .substr(0, 6);

        const convertedRgb = colorConverter.hex.rgb(hexColor);

        return {
            hex: '#' + hexColor,
            rgb: {
                r: convertedRgb[0],
                g: convertedRgb[1],
                b: convertedRgb[2]
            }
        };
    }

    _createColorInformationFromRgb(r, g, b) {
        const convertedHex = colorConverter.rgb.hex(r, g, b);

        return {
            hex: '#' + convertedHex,
            rgb: {
                r,
                g,
                b
            }
        };
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.initialValue,
            (newVal, oldVal) => {
                if (`${newVal}`.toLowerCase() !== `${oldVal}`.toLowerCase()) {
                    this.colorInformation.hex = `${newVal}`.toLowerCase();
                    this.updateColorFromColorInformation('hex');
                }
            });
    }
}

AlColorPickerController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-color-picker/controller.js